import { DocumentContext } from '@ContractBuilder/utils/get-document-context';

export const ctxIsPDF = (context: DocumentContext) => context === DocumentContext.PDF;
export const ctxIsTemplate = (context: DocumentContext) => context === DocumentContext.Template;
export const ctxIsBlocks = (context: DocumentContext) =>
  context === DocumentContext.Blocks || context === DocumentContext.Library;
